import React from "react";

export default function SubmitButton(props) {
  return (
    <button
      type="submit"
      disabled={props.loading || props.disabled}
      onClick={props.onClick ? props.onClick : null}
      style={props.style}
      className="submit-btn"
    >
      {props.text}
    </button>
  );
}

SubmitButton.defaultProps = {
  disabled: false,
  loading: false,
  style: {},
  text: "Submit",
};
